var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnauthorizedErrorPlaceholder = function SvgUnauthorizedErrorPlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 680,
    height: 805
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "unauthorized-error-placeholder_svg__a",
    x1: "50.005%",
    x2: "50.005%",
    y1: "99.994%",
    y2: "-.001%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "unauthorized-error-placeholder_svg__b",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#DEE2EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "unauthorized-error-placeholder_svg__c",
    x1: "50.889%",
    x2: "50.889%",
    y1: "54.667%",
    y2: "50.667%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "unauthorized-error-placeholder_svg__d",
    x1: "49.624%",
    x2: "49.624%",
    y1: "99.933%",
    y2: "-.191%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "unauthorized-error-placeholder_svg__e",
    x1: "50.002%",
    x2: "50.002%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 154.115,
    height: 16.642,
    x: 442.017,
    y: 284.605,
    fill: "#DEE2EB",
    fillRule: "nonzero",
    rx: 7.642
  }), /*#__PURE__*/React.createElement("rect", {
    width: 154.115,
    height: 16.642,
    x: 476.537,
    y: 298.784,
    fill: "#DEE2EB",
    fillRule: "nonzero",
    rx: 7.642
  }), /*#__PURE__*/React.createElement("rect", {
    width: 154.115,
    height: 16.642,
    x: 417.97,
    y: 311.115,
    fill: "#DEE2EB",
    fillRule: "nonzero",
    rx: 7.642
  }), /*#__PURE__*/React.createElement("rect", {
    width: 154.115,
    height: 16.642,
    x: 178.165,
    y: 475.097,
    fill: "#DEE2EB",
    fillRule: "nonzero",
    rx: 7.642
  }), /*#__PURE__*/React.createElement("rect", {
    width: 154.115,
    height: 16.642,
    x: 212.685,
    y: 489.277,
    fill: "#DEE2EB",
    fillRule: "nonzero",
    rx: 7.642
  }), /*#__PURE__*/React.createElement("rect", {
    width: 154.115,
    height: 16.642,
    x: 154.119,
    y: 501.599,
    fill: "#DEE2EB",
    fillRule: "nonzero",
    rx: 7.642
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#unauthorized-error-placeholder_svg__a)",
    fillRule: "nonzero",
    d: "M652.297 115.748c-11.128-1.627-86.2 36.45-184.833-60.957C413.9 1.903 361.434-3.729 324.666 2.171c-22.596 3.622-43.228 14.655-59.572 30.638C251.951 45.714 220.14 63.3 145.606 58.497 30.944 51.101.736 133.092.736 133.092L680 134.465s-3.658-5.952-9.597-10.656c-5.388-4.269-12.812-7.288-18.106-8.061z",
    opacity: 0.5,
    transform: "translate(0 670.753)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    fillRule: "nonzero",
    d: "M.767 804.687s30.208-81.992 144.87-74.595c74.533 4.826 106.352-12.783 119.457-25.68 16.313-16.014 36.937-27.017 59.51-30.638 36.769-5.9 89.243-.269 142.799 52.62 98.633 97.406 183.709 60.415 187.407 60.415 3.699 0 23.425 17.878 23.425 17.878H.767z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BEC4CF",
    fillRule: "nonzero",
    d: "M.767 805.687s30.208-81.992 144.87-74.595c74.533 4.826 106.352-12.783 119.457-25.68 16.313-16.014 36.937-27.017 59.51-30.638 36.769-5.9 89.243-.269 142.799 52.62 98.633 97.406 166.795 57.335 185.626 60.412 18.83 3.076 25.206 17.88 25.206 17.88H.767z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 154.115,
    height: 16.642,
    x: 77.039,
    y: 94.935,
    fill: "#DEE2EB",
    fillRule: "nonzero",
    rx: 7.642
  }), /*#__PURE__*/React.createElement("rect", {
    width: 154.115,
    height: 16.642,
    x: 111.566,
    y: 109.115,
    fill: "#DEE2EB",
    fillRule: "nonzero",
    rx: 7.642
  }), /*#__PURE__*/React.createElement("rect", {
    width: 154.115,
    height: 16.642,
    x: 53,
    y: 121.445,
    fill: "#DEE2EB",
    fillRule: "nonzero",
    rx: 7.642
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.349,
    cy: 62.265,
    r: 62.265,
    fill: "url(#unauthorized-error-placeholder_svg__b)",
    fillRule: "nonzero",
    opacity: 0.5,
    transform: "translate(97.303)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.652,
    cy: 62.265,
    r: 55.482,
    fill: "#FCCC63",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101938",
    fillRule: "nonzero",
    d: "M124.284 711.67h48.262v35.855h-48.262z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101938",
    fillRule: "nonzero",
    d: "m120.079 710.212 26.97-26.97a2.1 2.1 0 0 1 2.977 0l26.755 26.755a2.102 2.102 0 0 1-1.481 3.59l-53.71.216a2.104 2.104 0 0 1-1.511-3.591z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "m120.079 710.212 26.97-26.97a2.1 2.1 0 0 1 2.977 0l26.755 26.755a2.102 2.102 0 0 1-1.481 3.59l-53.71.216a2.104 2.104 0 0 1-1.511-3.591z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M147.793 731.35h.967a5.45 5.45 0 0 1 5.448 5.448v10.742h-11.863v-10.742a5.448 5.448 0 0 1 5.448-5.448z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.545,
    cy: 691.751,
    r: 2.969,
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M128.059 716.25h11.325v8.624h-11.325z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101938",
    fillRule: "nonzero",
    d: "M133.176 716.25h1.082v8.624h-1.082z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M158.251 716.25h11.325v8.624h-11.325z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101938",
    fillRule: "nonzero",
    d: "M163.376 716.25h1.082v8.624h-1.082z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#unauthorized-error-placeholder_svg__c)",
    fillRule: "nonzero",
    d: "M1.15.882c-.099-.023 0 0 0 0z",
    opacity: 0.2,
    transform: "translate(346.81 672.822)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#unauthorized-error-placeholder_svg__d)",
    fillRule: "nonzero",
    d: "M2.263 23.164h.093a.11.11 0 0 0 .069-.092.284.284 0 0 0 0-.092v-.077c-.077-.184-.254-.43-.353-.644l-.046-.115a.792.792 0 0 1 0-.154v-.069l1.657-5.44.038-.13s2.11.905 2.655 2.716c.314.878.33 1.835.046 2.724l-.038.092h.038v.997h2.302c.161-.077-.054-.276-.269-.475l-.053-.054-.138-.146a.663.663 0 0 1-.1-.146l-.039-.092v-.054h-.069v-.084a7.834 7.834 0 0 0-2.347-7.412 8.025 8.025 0 0 0 0-5.102c.214-.154 4.396-3.177 4.365-7.09.013-.21.013-.42 0-.63 0 0 .361-.298 0-.843V.706h-.291a1.14 1.14 0 0 0-.468.153s-.238.768 0 .967h-.062S6.775 7.197 5.118 7.964l-.115-.069V7.021a1.889 1.889 0 0 0 .652-.561l.061-.092.062-.107.046-.1c.033-.072.06-.146.084-.222v-.422c0-.22-.039-.438-.115-.645a.266.266 0 0 0-.07-.169l-.037-.084-.054-.092a.585.585 0 0 1 .146-.13.86.86 0 0 1 .345-.108h.36a.48.48 0 0 0 .123-.069.554.554 0 0 1 .2-.107h-.959l-.123-.054c.064.026.13.041.2.046h.306l.046-.038v-.062h-.138c-.104.014-.21.014-.314 0H5.5l-.092-.038a.505.505 0 1 0 .346-.952l.084-.053a.448.448 0 0 0 .153-.3.323.323 0 0 0 0-.145l-.053.046h-.046a.778.778 0 0 1-.499.138h-.061a2.263 2.263 0 0 1-.453-.169l-.13-.046H4.05c-.573.02-1.12.249-1.534.644a2.38 2.38 0 0 0-.261.307 3.006 3.006 0 0 1 .299-1.634H2.37l-.07.13c.037-.185.107-.362.208-.521h-.046a.622.622 0 0 0 0-.829C2.103.038 1.435.46 1.435.46c-.054.178-.09.36-.108.545L1.22.96c-.123.414-1.489 5.172.767 8.21a2.05 2.05 0 0 0 0 .192v5.125L.453 21.514l-.3 1.328 2.157.353-.047-.03zm.384-16.611c.122.1.256.186.4.253a.712.712 0 0 0 0 .146v.667l-.131.061c-.1-.33-.184-.713-.277-1.127h.008z",
    opacity: 0.2,
    transform: "translate(346.81 672.822)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CA7070",
    fillRule: "nonzero",
    d: "M356.907 675.017s.399-.338 0-.936c-.399-.599-1.136-.13-1.136-.13s-.268.866 0 1.066c.269.2 1.136 0 1.136 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00695C",
    fillRule: "nonzero",
    d: "M352.779 697.39h1.841a.607.607 0 0 0 .177.476c.245.284.767.63.514.768h-2.532v-1.243z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M354.659 697.866a.606.606 0 0 1-.177-.475h.13a.61.61 0 0 0 .177.475c.246.284.768.63.514.768h-.13c.23-.139-.269-.484-.514-.768z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00695C",
    fillRule: "nonzero",
    d: "m346.211 697.015 1.75.306a.887.887 0 0 0 .076.607c.192.39.614.897.36 1.005l-2.493-.407.307-1.511zm.844-22.812s-1.972 6.223 1.335 9.668l.96-.767s-1.957-6.79-.86-8.387c-1.934-.606-1.435-.514-1.435-.514z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CA7070",
    fillRule: "nonzero",
    d: "M348.42 674.748s.4-.337 0-.936c-.398-.598-1.135-.13-1.135-.13s-.268.867 0 1.066c.269.2 1.136 0 1.136 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M347.884 697.897a.884.884 0 0 1-.077-.606l-1.596-.261 1.75.291a.887.887 0 0 0 .076.607c.192.39.614.897.36 1.005h-.107c.17-.184-.222-.66-.406-1.036z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.872,
    height: 2.778,
    x: 349.127,
    y: 679.996,
    fill: "#CA7070",
    fillRule: "nonzero",
    rx: 0.859,
    transform: "rotate(180 350.063 681.385)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M349.211 683.51s-1.933-6.706-.882-8.355h.199c-1.097 1.596.86 8.386.86 8.386l-.96.767-.084-.092.867-.706z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.024,
    cy: 678.899,
    r: 2.072,
    fill: "#CA7070",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M350.761 681.838v-.906a.955.955 0 0 0 0-.2 2.073 2.073 0 0 0-.829-3.913h.116c.956 0 1.789.654 2.015 1.583a2.07 2.07 0 0 1-1.064 2.33.955.955 0 0 1 0 .2v.906c0 .517-.42.936-.936.936h-.115a.937.937 0 0 0 .813-.936z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00695C",
    fillRule: "nonzero",
    d: "M347.922 689.227s3.998.452 4.143 0a8.83 8.83 0 0 0 0-5.686 2.07 2.07 0 1 0-4.143 0v5.686z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    fillRule: "nonzero",
    d: "m347.922 689.227-1.803 8.286h1.803l1.872-6.138s2.302 1.005 2.939 3.008a4.396 4.396 0 0 1 0 3.138h1.941v-.092a8.616 8.616 0 0 0-2.624-8.202"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M351.797 689.227a8.842 8.842 0 0 0 0-5.686 2.072 2.072 0 0 0-1.941-2.064h.13c1.144 0 2.072.928 2.072 2.072a8.84 8.84 0 0 1 0 5.685c-.054.161-.599.208-1.282.2.591-.015 1.02-.07 1.02-.207z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00695C",
    fillRule: "nonzero",
    d: "M352.096 683.51s5.371-3.744 4.811-8.486h-1.197s-2.877 6.215-4.711 6.821c-1.834.607 1.097 1.665 1.097 1.665z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m349.756 691.505-1.834 6.039h-.268l1.872-6.138zm2.041-2.248h.269a8.618 8.618 0 0 1 2.624 8.202v.093h-.269v-.093a8.618 8.618 0 0 0-2.624-8.202zM356.707 675.07h.2c.537 4.75-4.81 8.487-4.81 8.487l-.131-.054c.598-.438 5.24-3.99 4.741-8.433z",
    fill: "#FFF",
    fillRule: "nonzero",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    fillRule: "nonzero",
    d: "M351.674 677.97c-.114.268-.194.55-.238.837a2.238 2.238 0 0 1-.951 1.458 2.1 2.1 0 0 1-.929.253 1.773 1.773 0 0 1-1.373-.414 1.705 1.705 0 0 1-.422-.844c-.21-.953.08-1.948.767-2.64a2.548 2.548 0 0 1 2.647-.56c.162.08.332.141.507.184.28.055.57-.037.767-.245a.463.463 0 0 1-.445.598c.31.15.666.169.99.054a.837.837 0 0 1-1.059.422c.376.168.785.252 1.197.246-.084 0-.253.16-.36.191a2.227 2.227 0 0 1-.4 0 .768.768 0 0 0-.698.46z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.95 676.604c.154.074.32.116.491.124a1.293 1.293 0 0 1-.645-.123.47.47 0 0 0 .469-.507l.106-.092a.46.46 0 0 1-.423.599zm-.414-.36a2.54 2.54 0 0 1-.507-.184 2.316 2.316 0 0 0-.767-.161c.317-.01.633.044.928.161.162.08.332.141.507.184h.069a.74.74 0 0 1-.23 0zm1.028 1.266c.107 0 .276-.192.36-.192a2.822 2.822 0 0 1-1.197-.245.777.777 0 0 0 .269.054c.34.129.702.192 1.066.184-.084 0-.253.16-.36.192a.912.912 0 0 1-.276 0l.138.007zm-3.146 3.008c.325-.012.643-.098.928-.253.501-.338.844-.864.952-1.458.043-.288.123-.569.238-.836a.765.765 0 0 1 .652-.43h.13a.765.765 0 0 0-.652.43 3.46 3.46 0 0 0-.238.836 2.238 2.238 0 0 1-.951 1.458 2.113 2.113 0 0 1-.929.253h-.13zm2.693-3.384a.844.844 0 0 0 .683-.437l.153-.046a.844.844 0 0 1-.836.483zM356.777 675.017s.399-.338 0-.936a.636.636 0 0 0-.5-.307.65.65 0 0 1 .63.307c.399.598 0 .936 0 .936a3.67 3.67 0 0 1-.767.084c.214-.01.427-.039.637-.084z",
    fill: "#FFF",
    fillRule: "nonzero",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5252",
    fillRule: "nonzero",
    d: "M365.922 667.566s-1.971 6.223 1.336 9.668l.959-.767s-1.957-6.79-.86-8.386c-1.933-.607-1.435-.515-1.435-.515z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6B9AD",
    fillRule: "nonzero",
    d: "M367.288 668.119s.4-.338 0-.936c-.399-.599-1.135-.13-1.135-.13s-.269.866 0 1.066c.268.2 1.135 0 1.135 0z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.872,
    height: 2.778,
    x: 367.994,
    y: 673.367,
    fill: "#F6B9AD",
    fillRule: "nonzero",
    rx: 0.859,
    transform: "rotate(180 368.93 674.756)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M368.079 676.904s-1.934-6.706-.883-8.355h.2c-1.098 1.595.859 8.386.859 8.386l-.96.767-.083-.092.867-.706z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.892,
    cy: 672.262,
    r: 2.072,
    fill: "#F6B9AD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M369.628 675.2v-.897a.836.836 0 0 0 0-.2 2.073 2.073 0 0 0-.828-3.913h.115a2.072 2.072 0 0 1 .951 3.913.955.955 0 0 1 0 .2v.906a.936.936 0 0 1-.936.936h-.115a.936.936 0 0 0 .813-.944z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5252",
    fillRule: "nonzero",
    d: "M366.79 682.59s3.997.452 4.143 0c.476-1.458-.767-3.07-.161-3.837.38-.551.442-1.263.16-1.872a2.069 2.069 0 0 0-2.071-2.071 2.07 2.07 0 0 0-2.071 2.071v5.709z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M370.78 678.784c.38-.552.442-1.264.16-1.872a2.072 2.072 0 0 0-2.071-2.072h-.13a2.07 2.07 0 0 1 1.94 2.064c.282.609.22 1.32-.16 1.872-.645.768.636 2.348.16 3.837-.045.138-.46.192-1.005.2.676 0 1.22-.04 1.274-.2.468-1.481-.813-3.062-.169-3.829z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6B9AD",
    fillRule: "nonzero",
    d: "M370.081 682.46a11.86 11.86 0 0 1 1.688 8.201v.093h-1.243a6.663 6.663 0 0 0 0-3.139 4.957 4.957 0 0 0-1.887-3.007l-1.205 6.138h-1.159l1.159-8.287h2.647zm7.036-11.924s.483-.2.276-.898c-.207-.698-1.043-.46-1.043-.46s-.514.767-.315 1.02c.2.253 1.082.338 1.082.338z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5252",
    fillRule: "nonzero",
    d: "M370.02 677.242s6.207-2.01 7.09-6.706l-1.152-.353s-4.603 5.102-6.506 5.14c-1.903.039.568 1.919.568 1.919z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "m376.895 670.543.191.062c-.882 4.696-7.09 6.706-7.09 6.706l-.107-.085c.73-.26 6.185-2.301 7.006-6.683zM368.355 684.6l-1.206 6.14h.27l1.166-5.97a2.955 2.955 0 0 0-.23-.169zm1.726-2.14h-.268a11.869 11.869 0 0 1 1.688 8.202v.092h.245v-.092a11.86 11.86 0 0 0-1.665-8.202zM376.979 670.467s.483-.2.276-.898a.635.635 0 0 0-.383-.437.65.65 0 0 1 .514.475c.207.69-.277.898-.277.898-.26-.02-.517-.07-.767-.146.21.053.422.09.637.108z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    fillRule: "nonzero",
    d: "m366.79 682.367-2.517 5.31c1.47.073 2.935.25 4.381.53 2.785.529 4.113-.768 4.113-.768l-1.788-5.072h-4.19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5252",
    fillRule: "nonzero",
    d: "M367.457 690.723s1.327.268 1.059.767h-2.386l.13-.767h1.197zm4.243 0s1.327.268 1.059.767h-2.386l.13-.767h1.197z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCCC63",
    fillRule: "nonzero",
    d: "M370.772 670.559s-3.185 4.511-1.727 6.368l-5.7-.13s1.588-10.22 7.427-6.238z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M370.772 670.559a4.856 4.856 0 0 0-2.225-.906 5.629 5.629 0 0 1 1.534.768s-3.184 4.511-1.726 6.368l-5.018-.115v.115l5.7.13c-1.45-1.849 1.735-6.36 1.735-6.36zm.207 11.808h-.4l1.796 5.041a4.052 4.052 0 0 1-2.64.921 4.225 4.225 0 0 0 3.07-.92l-1.826-5.042zm-3.522 8.356h-.269s1.328.268 1.06.767h.268c.268-.506-1.059-.767-1.059-.767zm4.243 0h-.268s1.327.268 1.058.767h.269c.268-.506-1.059-.767-1.059-.767z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#B3B3B3",
    strokeWidth: 0.767,
    d: "m510.443 573.117-7.397-41.31 23.425-1.144v42.454H542.5l16.028-45.622"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64.114,
    height: 45.622,
    x: 494.414,
    y: 568.797,
    fill: "#37A3BC",
    fillRule: "nonzero",
    rx: 20.947
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M536.338 568.797h-18.491c-12.583.038-22.773 10.229-22.811 22.811 0 .522 0 1.029.061 1.535.844-11.953 10.767-21.23 22.75-21.269h18.491c11.983.039 21.906 9.316 22.75 21.269 0-.506.062-1.02.062-1.535-.038-12.582-10.23-22.773-22.812-22.81z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#unauthorized-error-placeholder_svg__e)",
    fillRule: "nonzero",
    d: "M623.731 445.334c0 52.682-44.01 95.388-90.868 95.388s-94.882-42.706-94.882-95.388c0-52.68 48.024-95.387 94.89-95.387 46.865 0 90.86 42.706 90.86 95.387z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37A3BC",
    fillRule: "nonzero",
    d: "M619.38 445.334c0 50.219-41.946 90.923-86.617 90.923-44.671 0-90.447-40.704-90.447-90.923 0-50.218 45.791-90.891 90.454-90.891 44.664 0 86.61 40.665 86.61 90.891zm-100.49 94.115h20.095v7.021H518.89z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M532.77 354.097c-1.066 0-2.125 0-3.191.077 43.45 1.88 83.426 41.825 83.426 90.846s-39.975 88.966-83.396 90.846a74.21 74.21 0 0 0 3.192.076c44.663 0 86.618-40.704 86.618-90.922 0-50.218-41.985-90.923-86.649-90.923z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M447.434 445.334c0-49.497 44.502-89.771 88.528-90.891h-1.91c-44.663 0-90.447 40.704-90.447 90.922 0 50.219 45.776 90.923 90.44 90.923h1.91c-44.042-1.197-88.521-41.433-88.521-90.954z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37A3BC",
    fillRule: "nonzero",
    d: "M501.028 523.497h57.745v18.821h-57.745z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M501.028 361.034s-68.587 78.4 0 168.601l22.65-.076s-62.525-74.518-2.87-174.172l-11.148 2.54-8.632 3.107zm59.656-1.22s68.587 79.597 0 169.798l-22.65-.076s62.525-75.194 2.87-174.825l11.164 2.233 8.616 2.87z",
    opacity: 0.2
  }))));
};
export default SvgUnauthorizedErrorPlaceholder;